import React from 'react';
import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { CopyBlock, dracula } from "react-code-blocks";

import styles from './styles';

const BuiltOnNeurodiffeq = ( props ) => {
    const {classes} = props;

    return (
        <Container maxWidth={false} className={classes.blockContainer}>
            <Grid container spacing={2}>
                <Grid item sm={4}>
                    <Typography variant="h6" gutterBottom>
                        Built on the NeuroDiffEq library
                    </Typography>
                    <div>
                        PINN Hub is centered on NeuroDiffEq solver artifacts, starter docs, and reusable model exchange. Train locally with the upstream library, then publish or reload the resulting solver through the hub.
                    </div>
                </Grid>
                <Grid item sm={8}>
                    <CopyBlock
                        language="python"
                        text={`from neurodiffeq.solvers import Solver1D

# Load a pretrained solver from PINN Hub
             solver = Solver1D.load(name="project_name/equation_name")
                                                                
# Fine-tune it locally 
            solver.fit(max_epochs=1000) 

            # Save the updated solver back to PINN Hub
            solver.save(name="retrained_equation", save_to_hub=True)`}
                        theme={dracula}
                        showLineNumbers={true}
                        codeBlock
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

export default withStyles( styles )( BuiltOnNeurodiffeq );
